import { arrayRemove, deleteDoc, doc, getDoc, updateDoc } from "@firebase/firestore"
import { hideLoading, showLoading } from "./item-photos-delete-slice";
import { showErrorSnackbar, showSuccessSnackbar, showWarningSnackbar } from "../../../../../../../shared/snackbar/snackbar-slice";
import { deleteObject, ref } from "firebase/storage";
import { storage } from "../../../../../../../../firebase";
import { editItems } from "../../../../items-list-slice";
import { deleteItemPhotos } from "../item-photos-list/item-photos-list-slice";

export const getItemsDataService = async (dispatch, db, coll, id) => {
    try {
        const docRef = doc(db, coll, id);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
            return docSnap.data();
        } else {
            dispatch(showWarningSnackbar("This document no longer exists."));
        }
    } catch(e) {
        console.error("ItemsDelete getItemsDataService error: ", e);
    }
};

export const deleteItemPhotosService = async (dispatch, db, coll, id, url) => {
    dispatch(showLoading());
    try {
        const startIndex = url.indexOf("/o/") + 3;
        const endIndex = url.indexOf("?alt=media");
        // Extract the path component
        const encodedPath = url.substring(startIndex, endIndex);
        const photoPath = decodeURIComponent(encodedPath);
        const photoRef = ref(storage, photoPath);
        await deleteObject(photoRef);
        const itemRef = doc(db, coll, id);
        await updateDoc(itemRef, {
            image_url: arrayRemove(url)
        });
        await new Promise(resolve => setTimeout(resolve, 1000));
        const docSnap = await getDoc(doc(db, coll, id));
        const updatedData = docSnap.data();
        const data = {
            ...updatedData,
            id: id,
        };
        dispatch(editItems(data));
        dispatch(deleteItemPhotos(url));
        dispatch(showSuccessSnackbar('Photo deleted successfully!'));
    } catch(e) {
        dispatch(showErrorSnackbar('Something went wrong when deleting the photo.'));
        console.error("ItemsPhotoDelete deleteItemPhotosService error: ", e);
    }
    dispatch(hideLoading());
};